import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  // currentUser: User;
  // userFromApi: User;

  constructor(
      // private userService: UserService,
      // private authenticationService: AuthenticationService
  ) {
      // this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
      // this.userService.getById(this.currentUser.id).subscribe(user => {
      //     this.userFromApi = user;
      // });
  }

}
